import React, { FC, KeyboardEvent, useState } from "react";
import { icons } from "../../icons";
import {
  Container,
  IconBackground,
  Title,
  TitleWrapper,
  Content,
  CloseButton,
  CloseIcon,
  DocIcon
} from './styles'
import Doc from './document.svg'
import { useTranslation } from "react-i18next";

const BigAlert:FC<any> = (props) => {
  const [active, setActive] = useState<boolean>(true)
  const [t] = useTranslation()

  const {
    severity,
    message, 
    deleteItem = () => {},
    onClick,
    isGlobal,
  } = props

  const handleContentKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!onClick || (event.key !== 'Enter' && event.key !== ' ')) {
      return
    }
    event.preventDefault()
    onClick()
  }

  return (
    <Container role="status" active={active} $interactive={Boolean(onClick)}>
      <div
        onClick={onClick}
        onKeyDown={handleContentKeyDown}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        style={{display:'flex', alignItems:'flex-start'}}
      >
        <IconBackground>
          <DocIcon src={isGlobal ? icons.Warning : Doc} aria-hidden="true"/>
        </IconBackground>
        <TitleWrapper>
          <Title>
            {severity}
          </Title>
          <Content>
            {message}
          </Content>
        </TitleWrapper>
      </div>
      {!isGlobal &&
        <CloseButton
          type="button"
          aria-label={t("CLOSE")}
          onClick={(event) => {
            event.stopPropagation()
            setActive(false)
            deleteItem()
          }}
        >
          <CloseIcon src={icons.CloseIcon} aria-hidden="true"/>
        </CloseButton>
      }
    </Container>
  )
}


export default BigAlert
